import { createFileRoute, redirect } from "@tanstack/react-router";

// English schema alias: Product → /omnichannel
export const Route = createFileRoute("/product")({
  beforeLoad: () => {
    throw redirect({ to: "/omnichannel", replace: true });
  },
  component: () => null,
});
